import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Chapter1 } from './components/Chapter1';
import { Chapter2 } from './components/Chapter2';
import { Chapter3 } from './components/Chapter3';
import { Chapter4 } from './components/Chapter4';
import { Chapter5 } from './components/Chapter5';
import { Chapter6 } from './components/Chapter6';
import { Chapter7 } from './components/Chapter7';
import { Chapter8 } from './components/Chapter8';
import { Chapter9 } from './components/Chapter9';
import { Offer } from './components/Offer';
import { Disclaimer } from './components/shared/Disclaimer';
import { FakeNotifications } from './components/FakeNotifications';
import { ExitPopup } from './components/ExitPopup';
export function App() {
  useEffect(() => {
    // Set the page title to something relevant to the article
    document.title = 'Upptäckten som fick mig att se klart igen | Brainy Kosttillskott';
  }, []);
  return <div className="bg-[#f5f0e6] text-[#333333] min-h-screen font-serif" data-id="element-0">
      <main className="mx-auto px-4 sm:px-6 lg:px-8 max-w-[760px] lg:max-w-[1040px]" data-id="element-1">
        <Hero data-id="element-2" />
        <Chapter1 data-id="element-3" />
        <Chapter2 data-id="element-4" />
        <Chapter3 data-id="element-5" />
        <Chapter4 data-id="element-6" />
        <Chapter5 data-id="element-7" />
        <Chapter6 data-id="element-8" />
        <Chapter7 data-id="element-9" />
        <Chapter8 data-id="element-10" />
        <Chapter9 data-id="element-11" />
        <Offer data-id="element-12" />
        <footer className="py-8 text-center text-sm text-gray-600" data-id="element-13">
          <Disclaimer data-id="element-14" />
        </footer>
      </main>
      <FakeNotifications data-id="element-15" />
      <ExitPopup data-id="element-16" />
    </div>;
}